import * as React from 'react';
import PropTypes from 'prop-types';
import ConnectedThemeProvider from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/ThemeProvider';
import merge from 'lodash/merge';
import { createTheme } from '@material-ui/core';

const black = '#000000';

const customTheme = createTheme({
  palette: {
    primary: { main: '#000' },
  },
  typography: {
    fontFamily: 'Lexend, Roboto, Helvetica, sans-serif',
  },
});

const overrideTheme = (theme) => {
  merge(theme.overrides, {
    MainButton: {
      root: {
        backgroundColor: black,
      },
    },
    MuiButton: {
      contained: {
        backgroundColor: black,
      },
    },
    CallToAction: {
      popper: {
        display: 'none',
      },
    },
  });
};

export default function CustomThemeProvider({ children }) {
  return (
    <ConnectedThemeProvider customTheme={customTheme} withTheme={overrideTheme}>
      {children}
    </ConnectedThemeProvider>
  );
}

CustomThemeProvider.propTypes = {
  children: PropTypes.node,
};
